module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.46.056c1b54.png";